import { axios } from '../util/axios'
import lastLoginStorage from '../util/lastLoginStorage'
import platform from '../util/platform'
import SmartLock from '../util/smartLock'
import SecureStorage from '../util/secureStorage'

const API_ENDPOINT = '/v3/accounts'
const API_ENDPOINT_WITH_TOKEN = '/v3/accounts/create'
const API_ENDPOINT_WITH_TOKEN_AND_PHONE_VALIDATION = '/v4/accounts/create'
const API_ENDPOINT_CAPTCHA_REGISTRATION_V3 = '/v3/registration/captcha'
const API_ENDPOINT_CAPTCHA_REGISTRATION_V4 = '/v4/registration/captcha'

const secureStorage = new SecureStorage('signup')
const smartLock = new SmartLock('signup')

export const defaultApiRequest = (nickname, email, password, abTests) =>
  axios
    .post(
      API_ENDPOINT,
      {
        nickname,
        email: email.toLowerCase().trim(),
        password,
        platform,
      },
      {
        headers: {
          'X-TestAB-Groups': abTests || '',
        },
        withCredentials: true,
      }
    )
    .then(async ({ data }) => {
      lastLoginStorage.saveEmailLogin(data)
      await smartLock.saveCredential(email, password, nickname)
      await secureStorage.saveCredential(email, password)
      return { data, email }
    })

export const registerWithCaptcha = async (registrationData, abTests, captchaToken) => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT_CAPTCHA_REGISTRATION_V3}`,
      {
        ...registrationData,
        platform,
      },
      {
        headers: {
          'X-TestAB-Groups': abTests || '',
          'X-Accounts-Register-Recaptcha': captchaToken,
          strongPassword: 'strongPassword',
        },
        withCredentials: false,
      }
    )

    const { data, status } = response

    if (status !== 202) {
      lastLoginStorage.saveEmailLogin(data)
    }

    return { status, data }
  } catch (error) {
    console.error('API REQUEST ERROR', error)
    throw error
  }
}

export const registerWithCaptchaValidatingDocument = (registrationData, abTests, captchaToken) =>
  axios
    .post(
      `${API_ENDPOINT_CAPTCHA_REGISTRATION_V4}`,
      {
        ...registrationData,
        platform,
      },
      {
        headers: {
          'X-TestAB-Groups': abTests || '',
          'X-Accounts-Register-Recaptcha': captchaToken,
        },
        withCredentials: true,
      }
    )
    .then(async response => {
      const { data, status } = response
      if (status !== 202) {
        lastLoginStorage.saveEmailLogin(data)
      }
      return response
    })

export const registerAccountWithToken = (token, abTests) =>
  axios
    .post(
      API_ENDPOINT_WITH_TOKEN,
      {
        token,
        platform,
      },
      {
        headers: {
          'X-TestAB-Groups': abTests || '',
        },
        withCredentials: true,
      }
    )
    .then(async response => {
      const { data } = response
      lastLoginStorage.saveEmailLogin(data)
      return response
    })

export const registerAndValidateAccountWithToken = (token, sessionIds, abTests) =>
  axios
    .post(
      API_ENDPOINT_WITH_TOKEN_AND_PHONE_VALIDATION,
      {
        token,
        platform,
        sessionIds,
      },
      {
        headers: {
          'X-TestAB-Groups': abTests || '',
        },
        withCredentials: true,
      }
    )
    .then(async response => {
      const { data } = response
      lastLoginStorage.saveEmailLogin(data)
      return response
    })
